import ComponentModule from "@eisinc/Overrides/Components/ProductAddToListLink";

export * from "@eisinc/Overrides/Components/ProductAddToListLink";

export default ComponentModule;
